// extracted by mini-css-extract-plugin
module.exports = {"customTag":"MultiSelectQuestionFormItem_customTag__1iMp1"};